import angular from 'angular';

import '../services/metadata';
import '../services/errors';

const module = angular.module('whyline.controllers.metadata', [
    'whyline.services.metadata',
    'whyline.services.errors',
])

const MetadataController = ($scope, MetadataService, $state, ErrorService) => {

    $scope.placeId = $state.params.placeId ? $state.params.placeId : false;
    $scope.selectedFilters = [];
    $scope.fields = [];
    $scope.headers = [];
    $scope.metadata = [];

    (() => {
        MetadataService.getPlaceMetadataFields($scope.placeId)
            .then((fields) => {
                $scope.fields = fields;
                $scope.headers = fields.slice(0,5);
            })
            .catch(ErrorService.handler)
    })();

    $scope.addFilter = () => {
        const filter = { value: '', field: ''};
        $scope.selectedFilters.push(filter)
    }

    $scope.removeFilter = (index) => {
        $scope.selectedFilters.splice(index, 1)
    }

    $scope.removeAllFilters = () => {
        $scope.selectedFilters = [];
    }

    $scope.applyFilters = () => {
        MetadataService.getPlaceMetadata($scope.placeId, $scope.selectedFilters).then(metadata => $scope.metadata = metadata);
        console.log($scope.metadata);
    }
}

module.exports = module.controller('MetadataController', MetadataController);